import MarkdownIt from 'markdown-it';

// Match the reader description policy: text Markdown, inert HTML, HTTP(S)
// links only, and no remote image requests from description content.
const markdown = new MarkdownIt({ html: false, linkify: true, typographer: false });
markdown.validateLink = (value) => {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname);
  } catch {
    return false;
  }
};
markdown.renderer.rules.image = (tokens, index) => markdown.utils.escapeHtml(tokens[index].content);
markdown.renderer.rules.link_open = (tokens, index, options, _env, renderer) => {
  tokens[index].attrSet('target', '_blank');
  tokens[index].attrSet('rel', 'noopener noreferrer');
  return renderer.renderToken(tokens, index, options);
};
export function renderDescriptionMarkdown(value: string) {
  return markdown.render(value);
}

export type DescriptionFormat = 'bold' | 'italic' | 'heading' | 'list' | 'quote' | 'link';
export function formatDescription(
  value: string,
  start: number,
  end: number,
  format: DescriptionFormat,
) {
  const selected = value.slice(start, end);
  const wrappers = { bold: ['**', '**'], italic: ['*', '*'], link: ['[', '](https://)'] };
  let replacement: string, selectionStart: number, selectionEnd: number;
  if (format in wrappers) {
    const [before, after] = wrappers[format as keyof typeof wrappers];
    const text = selected || 'text';
    replacement = `${before}${text}${after}`;
    selectionStart = start + before.length;
    selectionEnd = selectionStart + text.length;
    if (format === 'link') {
      selectionStart = start + before.length + text.length + 2;
      selectionEnd = selectionStart + 'https://'.length;
    }
  } else {
    start = start === 0 ? 0 : value.lastIndexOf('\n', start - 1) + 1;
    const lineEnd = value.indexOf('\n', end);
    end = lineEnd < 0 ? value.length : lineEnd;
    const prefix = format === 'heading' ? '## ' : format === 'list' ? '- ' : '> ';
    replacement = value
      .slice(start, end)
      .split('\n')
      .map((line) => prefix + line)
      .join('\n');
    selectionStart = start;
    selectionEnd = start + replacement.length;
  }
  return {
    value: value.slice(0, start) + replacement + value.slice(end),
    selectionStart,
    selectionEnd,
  };
}
